import React from 'react';
import classnames from 'classnames';
import { Button } from '@xingternal/button';

import { Column, Row } from '@xingternal/xing-grid';
import { RoutesConfig } from '../../../RoutesConfig';
import styles from './AdminNavigation.css';
import { BackButton } from '../../shared/BackButton';

export const AdminNavigation = ({
  enableBackButton = false,
  enableBorder = false,
}: {
  enableBackButton?: boolean;
  enableBorder?: boolean;
}): React.ReactElement => {
  const containerClass = classnames(
    styles.navigationContainer,
    enableBorder && styles.navigationContainerBorder
  );

  const backButtonClass = classnames(!enableBackButton && styles.iconHidden);

  return (
    <Row className={containerClass}>
      <Column size={1} offset={3}>
        <BackButton
          className={backButtonClass}
          url={RoutesConfig.admin.adminTermsOverview.path}
        />
      </Column>

      <Column size={3} offset={5}>
        <Button
          data-cy="create-new"
          className={styles.createButton}
          to={RoutesConfig.admin.adminTermsCreateNew.path}
          size="medium"
          variant="primary"
        >
          Create new
        </Button>
      </Column>
    </Row>
  );
};
